<template>
    <nav class="navigation" :class="{'active': isOpened}" v-clickoutside="hide">
        <div class="navigation-inner">
            <h6 class="navigation-user-name">{{ user.first_name + ' ' + user.last_name  }}</h6>

            <span class="navigation-close" @click.stop="exit">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path id="ic_close_24px" d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" transform="translate(-5 -5)"/></svg>
            </span>

            <div class="navigation-list" :class="{'loading': folderLoading}" v-loading="folderLoading">
                <router-link @click.native="selectFolder(item)" :to="{name:'home'}" class="navigation-list-item" v-for="(item, index) in $store.state.folders" :key="index" >
                    {{item.path | formatRootFolderName }}
                </router-link>
            </div>

            <div class="navigation-list" v-if="$store.state.folders.length === 0">
                <a class="navigation-list-item">
                    No folders
                </a>
            </div>

            <div class="navigation-list" v-if="['users', 'settings', 'orders','addresses'].indexOf($route.name) === -1">
              <div class="sidebar" v-loading="sidebarLoading">
                <div class="sidebar-inner">

                  <div class="sidebar-list primary">

                    <div v-if="$store.state.activeCategory" class="sidebar-list-breadcrumbs">
                      <p class="sidebar-list-title"  @click="setCategoryLocal($store.state.activeCategory)">
                        {{$store.state.activeCategory}}
                      </p>
                    </div>

                  </div>

                  <div class="sidebar-filter">
                    <template>
                      <div class="sidebar-list dropdown"
                           v-for="(item, filter) in Object.keys($store.state.filters).sort()
                              .filter(key => $store.state.activeCategory === key)
                              .reduce((obj, key) => {
                                obj[key] = $store.state.filters[key]
                                return obj
                              }, {})"
                           :key="filter"
                           :class="{'active': $store.state.expandedFilter.indexOf(filter) !== -1}">
                        <p class="sidebar-list-title" @click="setExpandedFilterLocal(filter)">Subcategory</p>

                        <div class="sidebar-list-inner">
                          <label class="sidebar-list-item" v-for="check in item" :key="check">
                            <input type="checkbox" :value="check" :id="check" v-model="$store.state.checkedValues" @change="setFilterLocal(filter, check, item, 1000)">
                            <span class="checkmark"></span>
                            {{check}}
                          </label>
                        </div>
                      </div>
                    </template>
                    <template v-for="filter in $store.state.filtersOrder">
                      <template v-if="typeof $store.state.filters[filter] !== 'undefined'">
                        <div class="sidebar-list dropdown"
                             :key="filter"
                             :class="{'active': $store.state.expandedFilter.indexOf(filter) !== -1}">
                          <p class="sidebar-list-title" @click="setExpandedFilterLocal(filter)">{{filter}}</p>

                          <div class="sidebar-list-inner">
                            <label class="sidebar-list-item" v-for="check in $store.state.filters[filter]" :key="check">
                              <input type="checkbox" :value="check" :id="check" v-model="$store.state.checkedValues" @change="setFilterLocal(filter, check, $store.state.filters[filter], 1000)">
                              <span class="checkmark"></span>
                              {{check}}
                            </label>
                          </div>
                        </div>
                      </template>
                    </template>

                  </div>

                </div>
              </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'
import { mapState } from 'vuex'
import axios from 'axios'

const CancelToken = axios.CancelToken

export default {
  name: 'Navigation',
  data () {
    return {
      folderLoading: true,
      isOpened: false,
      loading: false,
      windowWidth: 0,
      categories: [],
      folders: [],
      token: null,
      sidebarLoading: false,
      foldersOrder: process.env.VUE_APP_FOLDERS_ORDER
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted () {
    EventBus.$on('navigation-open', (payload) => (this.isOpened = payload))
    EventBus.$on('reload-navigation', () => this.loadFolders())
    window.removeEventListener('resize', this.handleResize)
    this.loadFolders()
  },
  destroyed () {
    EventBus.$off('navigation-open')
    EventBus.$off('reload-navigation')
  },
  computed: {
    ...mapState(['user'])
  },
  directives: {
    clickoutside: {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his childrens
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
      stopProp (event) { event.stopPropagation() }
    }
  },
  methods: {
    hide (e) {
      this.isOpened = false
    },
    handleResize () {
      this.windowWidth = window.innerWidth
      if (this.windowWidth > 769) {
        this.isOpened = false
      }
    },
    resetNav () {
      this.isOpened = false
    },
    selected (element) {
      EventBus.$emit('selected-category', element)
      EventBus.$emit('navigation-open', false)
    },
    loadFilters () {
      if (this.$store.state.assetQuery.path !== '') {
        if (this.token) {
          this.token.cancel()
        }
        this.token = CancelToken.source()

        this.sidebarLoading = true
        HTTP({
          method: 'GET',
          url: '/api/v1/assets/filters',
          params: {
            path: this.$store.state.assetQuery.path,
            search: this.$store.state.assetQuery.search,
            filter: this.$store.state.assetQuery.filter,
            imageSize: this.$store.state.assetQuery.imageSize,
            sort: this.$store.state.assetQuery.sort
          },
          cancelToken: this.token.token,
          crossdomain: true
        })
          .then(response => {
            if (response.data.data) {
              this.sidebarLoading = false
              this.setSidebarValues('filters', typeof response.data.data.filters !== 'undefined' ? response.data.data.filters : [])
              this.setSidebarValues('filtersOrder', typeof response.data.data.order !== 'undefined' ? response.data.data.order : [])
            }
          })
          .catch(() => {
            this.sidebarLoading = false
            this.setSidebarValues('filters', [])
          })
      }
    },
    loadFolders () {
      HTTP({
        method: 'GET',
        url: '/api/v1/watchfolders/',
        crossdomain: true
      }).then(response => {
        this.folders = response.data.data
        if (this.foldersOrder) {
          let sortArray = this.foldersOrder.split(',')
          this.folders.sort(function (a, b) {
            let A = a.path
            let B = b.path

            let aIndex = sortArray.findIndex(function (item) {
              return A.endsWith(item)
            })

            let bIndex = sortArray.findIndex(function (item) {
              return B.endsWith(item)
            })

            if (aIndex === -1) {
              aIndex = Math.floor(Math.random() * (1000 - 100) + 100)
            }

            if (bIndex === -1) {
              bIndex = Math.floor(Math.random() * (1000 - 100) + 100)
            }

            return aIndex > bIndex ? 1 : -1
          })
        }
        this.$store.dispatch('setFolders', this.folders)
        this.selectFolder(this.folders[0])
        this.folderLoading = false
      }).catch(() => {
        this.folderLoading = false
      })
    },
    toggleDropdown (name) {
      this.$set(this.showList, name, !this.showList[name])
    },
    exit () {
      this.isOpened = false
    },
    setExpandedFilterLocal (filter) {
      this.setExpandedFilter(filter)
    },
    setCategoryLocal (cat) {
      this.setCategory(cat)
      this.loadFilters()
    },
    resetCategoryLocal () {
      this.resetCategory()
    },
    setFilterLocal (key, value = null, values = null, debounceDuration = false) {
      this.setFilter(key, value, values, debounceDuration)
    }
  }
}
</script>
